import type { RevenueResponse } from '@shared/outpatientRevenue';
import type { ResolvedMetric } from '../components/prototypes/budgetSpec';
export type OutpatientViewMetric={key:string;label:string;money:boolean;card:boolean;resolved:ResolvedMetric};
export function outpatientViewMetrics(d:RevenueResponse):OutpatientViewMetric[]{
 const p=d.performance,n=d.months.length;
 const context=(key:string)=>{const m=p.context.find(m=>m.key===key)!;return [m.current,m.budget,m.previous] as const;};
 const definitions:[string,string,string,boolean,boolean,readonly (number|null)[],boolean][]=[
  ['revenue',p.headline.label,'千円',true,true,[p.headline.current,p.headline.budget,p.headline.previous],p.headline.budget!=null],
  ['patients','実患者数','人',false,true,[p.patients.current,null,p.patients.previous],false],
  ['patientDays','受診延日数','人日',false,true,[d.current.patientDays,null,d.previous?.patientDays??null],false],
  ['unit','受診1日あたり収入','円/日',false,true,[d.current.unit,null,d.previous?.unit??null],false],
  ['ambulance','救急車搬入','件',false,true,context('ambulance'),true],
  ['ambulanceAdmissions','救急車からの入院','件',false,true,context('ambulanceAdmissions'),true],
  ['ambulanceAdmissionRate','救急搬入からの入院率','%',false,true,context('ambulanceAdmissionRate'),false],
  ['chemoRevenue','化学療法枠の収入','千円',true,true,context('chemoRevenue'),false],
  ['chemoPatientDays','化学療法枠の受診日数','人日',false,false,context('chemoPatientDays'),false],
 ];
 return definitions.map(([key,label,unit,money,card,values,grade])=>{
  const intensive=['patients','unit','ambulanceAdmissionRate'].includes(key);
  const periodValue=(v:number|null)=>v==null?null:v/(money?1000:1)/(intensive?1:n);
  const monthlyValue=(v:number|null)=>v==null?null:v/(money?1000:1);
  const specKey=key==='revenue'?'外来収入':key==='chemoRevenue'?'外来化学療法収入':`外来_${key}`;
  const [current,budget,prevYear]=values.map(periodValue);
  return {key,label,money,card,resolved:{spec:{key:specKey,label,unit,direction:grade&&budget!=null?'higher_is_better':'neutral'},current,budget,prevYear,prevMonth:null,trend:p.trends[key].map(t=>({date:`${t.ym.slice(0,4)}-${t.ym.slice(4)}-01`,actual:monthlyValue(t.actual),budget:monthlyValue(t.budget),prevYear:monthlyValue(t.previous)}))}};
 });
}
